import React, { useCallback, useState } from 'react';

export type ContextMenu = {
  mouseX: number;
  mouseY: number;
} | null;

export const useContextMenu = () => {
  const [contextMenu, setContextMenu] = useState<ContextMenu>(null);

  const handleContextMenu = useCallback(
    (event: React.MouseEvent) => {
      console.log('handleContextMenu');
      event.preventDefault();
      setContextMenu(
        contextMenu === null
          ? {
              mouseX: event.clientX + 2,
              mouseY: event.clientY - 6,
            }
          : // repeated contextmenu when it is already open closes it with Chrome 84 on Ubuntu
            // Other native context menus might behave different.
            // With this behavior we prevent contextmenu from the backdrop to re-locale existing context menus.
            null,
      );
    },
    [contextMenu],
  );

  const closeContextMenu = useCallback(() => {
    setContextMenu(null);
  }, []);

  return { contextMenu, handleContextMenu, closeContextMenu };
};
